import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CommentViewerRefreshEvent } from 'src/app/models/events/comment-viewer-refresh-event';

@Injectable({
    providedIn: 'root',
})
export class ViewerEventsService {
    /**
     * Emis lorsque le contenu du document commentaire a changé.
     */
    public commentChanged = new Subject<CommentViewerRefreshEvent>();
}
